// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empnotificationspage-inline-1 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.empnotificationspage-inline-2 {
  text-align: center;
  color: #94a3b8;
  padding: 30px;
  font-size: 13px;
}

.empnotificationspage-inline-3 {
  font-size: 10px;
  color: #6366f1;
  font-weight: 600;
}

.empnotificationspage-inline-4 {
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
}

.empnotificationspage-inline-5 {
  font-weight: 700;
  margin-bottom: 6px;
}

.empnotificationspage-inline-6 {
  color: #475569;
  font-size: 13px;
}

.empnotificationspage-inline-7 {
  margin-top: 10px;
}

.empnotificationspage-dyn-1 {
  cursor: pointer;
  background: var(--empnotificationspage-1-background);
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpNotificationsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oDAAoD;EACpD,kBAAkB;AACpB","sourcesContent":[".empnotificationspage-inline-1 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.empnotificationspage-inline-2 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 30px;\n  font-size: 13px;\n}\n\n.empnotificationspage-inline-3 {\n  font-size: 10px;\n  color: #6366f1;\n  font-weight: 600;\n}\n\n.empnotificationspage-inline-4 {\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n  background: #fff;\n}\n\n.empnotificationspage-inline-5 {\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.empnotificationspage-inline-6 {\n  color: #475569;\n  font-size: 13px;\n}\n\n.empnotificationspage-inline-7 {\n  margin-top: 10px;\n}\n\n.empnotificationspage-dyn-1 {\n  cursor: pointer;\n  background: var(--empnotificationspage-1-background);\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
